import { t } from '@lingui/core/macro';
import { Button, Stack, Typography } from '@mui/material';
import { BasicModal } from 'components/modals/BasicModal';
import type { FC } from 'react';

type Props = {
  onClose: VoidFunction;
};

export const SsoAndSmsOtpAuthenticationModal: FC<Props> = ({ onClose }) => {
  const onContinue = () => {
    window.open('/strong_authentication', '_blank', 'noopener');
    onClose();
  };

  return (
    <BasicModal open onClose={onClose} title={t`Authentification forte`}>
      <Stack spacing={3}>
        <Typography>
          {t`Cette action sensible nécessite une authentification forte. Un nouvel onglet va s’ouvrir pour vous identifier via SSO, puis confirmer avec un code reçu par SMS. Revenez ensuite ici pour relancer votre action.`}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="contained" color="inherit" onClick={onClose}>
            {t`Annuler`}
          </Button>
          <Button variant="contained" onClick={onContinue}>
            {t`Continuer`}
          </Button>
        </Stack>
      </Stack>
    </BasicModal>
  );
};
